"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingReportFileMimeType = void 0;
exports.RoutingReportFileMimeType = {
    TextCsv: "text/csv",
    ApplicationVndGoogleAppsSpreadsheet: "application/vnd.google-apps.spreadsheet",
};
//# sourceMappingURL=routing-report-file-mime-type.js.map